export enum InvoiceStatuses {
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
  PAID = 'paid',
  ERROR = 'error',
  CANCELED = 'canceled',
  REFUNDED = 'refunded',
  PENDING_SETTLEMENT = 'pending_settlement',
  SCHEDULED = 'scheduled',
  OVERDUE = 'overdue'
}

export enum TransactionStatuses {
  CREATED = 'created',
  PROCESSING = 'processing',
  AUTHORIZED = 'authorized',
  SUCCEEDED = 'succeeded',
  CANCELED = 'canceled',
  ERROR = 'error',
  UNKNOWN = 'unknown',
  REFUNDED = 'refunded',
  PENDING = 'pending',
  TIMEOUT = 'timeout'
}
